import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect on client (runs before paint), useEffect on server (avoids
// the Next.js SSR warning; layout effects can't run during server rendering).
export const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect
